import Button from "components/formElements/Button/Button";
import NotFoundImage from "images/404.png";
import TalaeraRoutes from "components/routes/TalaeraRoutes";
import "./style.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleCatalog = () => {
    navigate(TalaeraRoutes.LIBRARY_ROOT.path);
  };

  const handleDashboard = () => {
    navigate(TalaeraRoutes.ROOT.path);
  };

  return (
    <div className="error-container">
      <div className="error-content-container">
        <div className="error-conatiner-right">
          <span className="error-heading">Oops!</span>
          <span className="error-title">{t("ErrorPage.contentRemoved")} </span>
          <span className="error-description">{t("ErrorPage.somethingNew")}</span>
          <div className="error-button-container">
            <Button className={"btn btn-primary"} onClick={handleCatalog}>
              {t("ErrorPage.browseCata")}
            </Button>
            <Button className={"btn btn-text btn-secondary"} onClick={handleDashboard}>
              {t("ErrorPage.toDashboard")}
            </Button>
          </div>
        </div>
        <div className="error-conatiner-left">
          <img src={NotFoundImage} alt="403" />
        </div>
      </div>
    </div>
  );
};
